import '../../Css/Map.css';
import { Modal } from 'react-bootstrap';
import Map from '../../Pages/Map';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkedAlt, faTimes } from '@fortawesome/free-solid-svg-icons';

export default function ModalMap ({location, show, setMapPop}) {

    const close = () => {
        setMapPop({ show: false });
    }
    return (
        !show?null:
        <Modal show={true} size='lg' style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span> <FontAwesomeIcon icon={faMapMarkedAlt} size='lg' />&nbsp;
                    انتخاب از نقشه
                </span>
                <FontAwesomeIcon icon={faTimes} size='lg' onClick={close} />

            </Modal.Header>
            <Modal.Body className='bodyStyle' style={{paddingTop:0}}>
                <Map location={{ lat: location.lat, lng: location.lng, zoom: location.zoom }} />
            </Modal.Body>
        </Modal>
    );
};
